import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBell = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 111,
	height: 95,
	viewBox: "0 0 111 95",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M64 12.5C64 8.08172 60.4183 4.5 56 4.5C51.5817 4.5 48 8.08172 48 12.5L48 13.5L64 13.5L64 12.5Z",
			fill: "#F2F4FA"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M48.5 13L48.5 12.5C48.5 8.35786 51.8579 5 56 5C60.1421 5 63.5 8.35786 63.5 12.5L63.5 13L48.5 13ZM56 4.5C60.4183 4.5 64 8.08172 64 12.5L64 13.5L48 13.5L48 12.5C48 8.08172 51.5817 4.5 56 4.5Z",
			fill: "#A5A8BA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M45.5 79C45.5 84.799 50.201 89.5 56 89.5C61.799 89.5 66.5 84.799 66.5 79V78H45.5V79Z",
			fill: "#E0E5F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M66 78.5V79C66 84.5228 61.5228 89 56 89C50.4772 89 46 84.5228 46 79V78.5H66ZM56 89.5C50.201 89.5 45.5 84.799 45.5 79V78H66.5V79C66.5 84.799 61.799 89.5 56 89.5Z",
			fill: "#A5A8BA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28.5 39.25C28.5 23.648 41.148 11 56.75 11C72.352 11 85 23.648 85 39.25V69H28.5V39.25Z",
			fill: "#F2F4FA"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M83.5 68.5V40C83.5 24.2599 70.7401 11.5 55 11.5C39.2599 11.5 26.5 24.2599 26.5 40V68.5H83.5ZM55 11C38.9837 11 26 23.9837 26 40V69H84V40C84 23.9837 71.0163 11 55 11Z",
			fill: "#A5A8BA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.5 79C19.5 73.4772 23.9772 69 29.5 69H83C88.5229 69 93 73.4772 93 79H19.5Z",
			fill: "#F2F4FA"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M90.75 76.25C90.75 76.8023 90.3023 77.25 89.75 77.25L21.25 77.25C20.6977 77.25 20.25 76.8023 20.25 76.25C20.25 75.6977 20.6977 75.25 21.25 75.25L89.75 75.25C90.3023 75.25 90.75 75.6977 90.75 76.25Z",
			fill: "#E0E5F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M82.5 69H27.5C22.6972 69 18.7731 72.762 18.5137 77.5H91.4863C91.2269 72.762 87.3028 69 82.5 69ZM91.9871 77.5C91.7271 72.4857 87.579 68.5 82.5 68.5H27.5C22.421 68.5 18.2729 72.4857 18.0129 77.5C18.0043 77.6656 18 77.8323 18 78H92C92 77.8323 91.9957 77.6656 91.9871 77.5Z",
			fill: "#A5A8BA"
		})
	]
});
const ForwardRef = forwardRef(SvgBell);
export default ForwardRef;
